import { jsx as _jsx } from "react/jsx-runtime";
import { Link as MuiLink } from "@mui/material";
import { Link } from "react-router";
export const NavbarLink = ({ children, active = false, centered = false, svgHeight = 32, hover = true, sx, ...props }) => (_jsx(MuiLink, { component: Link, "aria-current": active ? "page" : undefined, sx: [
        {
            position: "relative",
            display: "flex",
            alignItems: "center",
            ...(centered && { justifyContent: "center" }),
            svg: { height: svgHeight, mr: 0.5, mt: -0.5 },
            span: (theme) => theme.Navbar.typography,
            px: 1.5,
            py: 0.75,
            textDecoration: "none",
            "&::after": {
                content: '""',
                position: "absolute",
                left: 0,
                right: 0,
                bottom: 0,
                height: (theme) => theme.Navbar.indicator.height,
                borderRadius: (theme) => theme.Navbar.indicator.radius,
                backgroundColor: (theme) => theme.palette.primary.main,
                transformOrigin: "left center",
                transform: active ? "scaleX(1)" : "scaleX(0)",
                transition: (theme) => theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shortest,
                    easing: "ease-in",
                }),
            },
            "&:hover::after": hover
                ? {
                    transform: "scaleX(1)",
                }
                : null,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
    ], ...props, children: children }));
//# sourceMappingURL=NavbarLink.js.map